import { MutableRefObject } from 'react';

type ForwardedRef<T> = ((instance: T | null) => void) | MutableRefObject<T | null> | null;

export const mergeRef = <T>(...refs: ForwardedRef<T>[]) => {
  return (instance: T | null) => {
    refs.forEach((ref) => {
      if (typeof ref === 'function') {
        ref(instance);
      }
      if (ref && 'current' in ref) {
        ref.current = instance;
      }
    });
  };
};

export const useMergeRef = <T>(...refs: ForwardedRef<T>[]) => {
  return mergeRef(...refs);
};
